module.exports = __webpack_public_path__ + "static/media/img_signin_admin.39e5cc71.webp";